import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getUserService,
  getUserTotalCoinsService,
  setLocationService,
  getProfileOrderAndServicesCountBadgesService,
} from "../../services/user.service";

export const getUserDetails = createAsyncThunk("getUserDetails", async () => {
  return await getUserService();
});

export const getUserTotalCoins = createAsyncThunk(
  "getUserTotalCoins",
  async () => {
    return await getUserTotalCoinsService();
  }
);

export const setLocation = createAsyncThunk(
  "/setLocation",
  async (payload, { rejectWithValue }) => {
    return await setLocationService(payload, rejectWithValue);
  }
);

export const getProfileOrderAndServicesCountBadges = createAsyncThunk(
  "/getProfileOrderAndServicesCountBadges",
  async (params, { rejectWithValue }) => {
    return await getProfileOrderAndServicesCountBadgesService(
      params,
      rejectWithValue
    );
  }
);
